import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import classNames from 'classnames';
import { CollapsibleTextContext } from './CollapsibleText.Content/CollapsibleText.Content.es.js';
import { CollapsibleTextProvider } from './CollapsibleText.Context/provider.es.js';
import { CollapsibleTextToggle } from './CollapsibleText.Toggle/CollapsibleText.Toggle.es.js';

const CollapsibleText = ({ disabled = false, maxLines = 3, className, children })=>{
    const [collapsed, setCollapsed] = useState(false);
    const [expanded, setExpanded] = useState(false);
    return jsx(CollapsibleTextProvider, {
        collapsed: collapsed,
        disabled: disabled,
        expanded: expanded,
        maxLines: maxLines,
        setCollapsed: setCollapsed,
        setExpanded: setExpanded,
        children: jsx("div", {
            className: classNames('cb-collapsible-text', className),
            children: children
        })
    });
};
CollapsibleText.Toggle = CollapsibleTextToggle;
CollapsibleText.Content = CollapsibleTextContext;

export { CollapsibleText, CollapsibleText as default };
//# sourceMappingURL=CollapsibleText.es.js.map
